<div class="flex flex-col h-screen">
    <div class="flex w-full items-start justify-between p-4 md:p-8 border-b border-gray-200 md:border-0">
        <img [src]="assetUrl + 'icons/gloget_logo-trans.png'" class="w-[96px]" alt="Glo logo" />
        <div class="flex flex-end py-1 p-0 md:hidden">
            <img [src]="assetUrl + 'icons/menu.svg'">
        </div>
    </div>
    <div class="flex w-full h-screen">

        <div class="form-1 w-full md:w-1/2 flex justify-center  items-center">

            <div class="w-full max-w-[360px] px-6">
                <h1 class="text-md md:text-2xl text-center text-gray-900 pb-3 pt-6 md:pt-12 whitespace-nowrap">Grow your business with us</h1>
                <p class="text-md text-gray-600 text-left md:text-center pb-8">Discover how easy it is to manage loyal customers through our platform.</p>
    
                <form class="flex flex-col gap-4">
                    <label class="flex flex-col">
                        Name
                        <input type="text" placeholder="Insert your fullname" />
                    </label>
                    <label class="flex flex-col">
                        Email
                        <input type="email" placeholder="oliviahostler@example.com" />
                    </label>
    
                    <div class="flex flex-col pt-10">
                        <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Schedule on a demo</button>
                    </div>
                </form>
            </div>
        </div>
    
        <div 
            class="hidden md:flex relative w-1/2 flex justify-center items-end bg-cover bg-center text-white p-10"
            [style.background-image]="'url(' + assetUrl + 'img/request-demo.jpg)'"
        >
            <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-0"></div>
            <div class="w-full max-w-[600px] relative z-10">
                <div class="flex w-full items-start pb-4">
                    <img [src]="assetUrl + 'icons/Star.png'">
                </div>
                <h2 class="text-6xl mb-4 text-white">Smart Scheduling, Happy Customer</h2>
                <p class="mb-6 text-lg text-white">
                    Create a free account and get full access to all features for 30-days. No credit card needed. 
                    Get started in 2 minutes.
                </p>
                <div class="flex items-center text-md ">
                    <div class="flex mr-2">
                        <img [src]="assetUrl + 'img/avatars.png'">
                    </div>
                    <div class="flex flex-col items-center gap-1 ">
                        <span class="flex items-center text-white">
                            <img [src]="assetUrl + 'icons/5stars.svg'" class="pr-2 h-5">
                            <span class="text-white pt-1">5.0</span>
                        </span>
                        <span class="text-white">from 200+ reviews</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  </div>
  